import { render, staticRenderFns } from "./TicketListTable.vue?vue&type=template&id=6455a104&scoped=true&"
import script from "./TicketListTable.vue?vue&type=script&lang=js&"
export * from "./TicketListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6455a104",
  null
  
)

export default component.exports